// https://annuities.myaccount.pacificlife.com/enroll-ui/client
import React from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { Header, Footer } from "./components";
import "react-datepicker/dist/react-datepicker.css";

const FPLogin = () => {
    const handlelogin = async (e) => {
        e.preventDefault();
        window.location.href = "/dashboard.html";
    };
    const handleRegister = async (e) => {
        e.preventDefault();
        window.location.href = "/enroll-ui/fp";
    };
    return (
        <>
            <Header />
            <div className="mainMyAccount">
                <h1 className="heading">
                    Welcome to the Pacific Life Life Insurance Financial
                    Professional Portal
                </h1>
                <Form>
                    <div className="buttons-myaccount">
                        <Button
                            variant="primary"
                            type="submit"
                            onClick={handlelogin}
                            data-track="analytics"
                        >
                            Login
                        </Button>
                        <Button
                            variant="primary"
                            type="submit"
                            onClick={handleRegister}
                            data-track="analytics"
                        >
                            Register
                        </Button>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                    </div>
                </Form>
            </div>
            <Footer />
        </>
    );
};

export default FPLogin;
